export default function OrganigramaPage() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex justify-center">
          <a
            href="/documente/organigrama/ORGANIGRAMA 2025A_001.png"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/documente/organigrama/ORGANIGRAMA 2025A_001.png"
              alt="Organigrama"
              className="w-full max-w-full h-auto object-contain"
            />
          </a>
        </div>
      </main>
    </div>
  );
}
